import { render } from "./PossibleFraudPayments.vue?vue&type=template&id=5ee8e666&scoped=true"
import script from "./PossibleFraudPayments.vue?vue&type=script&lang=js"
export * from "./PossibleFraudPayments.vue?vue&type=script&lang=js"

import "./PossibleFraudPayments.vue?vue&type=style&index=0&id=5ee8e666&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee8e666"]])

export default __exports__